module.exports = __webpack_public_path__ + "img/Wp_2071.75bc4d20.png";